import { useWatch } from "react-hook-form";

import { MaskedField } from "@/components/Form/RHF/FormFields/MaskedField/maskedField.component";
import { StrictTextField } from "@/components/Form/RHF/FormFields/StrictTextField/strictTextfield.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { LicensePlateFormValues } from "./licensePlate.schema";
import { LicensePlateTypes } from "./licensePlate.types";

const MAX_LENGTH = 8;

const LicensePlateInput = () => {
    const { t } = useGranite();
    const chosenLicensePlateType = useWatch<LicensePlateFormValues>({
        name: "licensePlateType"
    });

    return (
        <>
            {chosenLicensePlateType ===
                LicensePlateTypes.LICENSE_PLATE_CAR_STANDARD && (
                <MaskedField<LicensePlateFormValues>
                    name="licensePlate"
                    label={t("ecommerce.licensePlate.fillInLicensePlate")}
                    optionalIndication={false}
                    autoComplete="off"
                    required={false}
                    inputMask={{
                        mask: ["A-AAA-999", "9-AAA-999"],
                        placeholder: "_"
                    }}
                />
            )}
            {chosenLicensePlateType ===
                LicensePlateTypes.LICENSE_PLATE_CAR_PERSONALIZED && (
                <StrictTextField<LicensePlateFormValues>
                    name="licensePlate"
                    label={t("ecommerce.licensePlate.fillInLicensePlate")}
                    optionalIndication={false}
                    required={false}
                    maxLength={MAX_LENGTH}
                    inputTransformer={(value) =>
                        value.toUpperCase().slice(0, MAX_LENGTH)
                    }
                    incorrectPattern={/[^A-Z0-9-]+/}
                />
            )}
        </>
    );
};

export { LicensePlateInput };
